var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDragdropIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.196,
    height: 24.858,
    viewBox: "0 0 22.196 24.858",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2527",
    "data-name": "Grupo 2527",
    transform: "translate(-15 -209.092)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icomoon-free_move-down",
    d: "M9.286,5.071v6.214H3.071V5.071ZM11.357,3H1V13.357H11.357ZM1,17.5H4.107v2.071H1Zm4.143,0H8.25v2.071H5.143Zm4.143,0h2.071v3.107H9.286ZM1,24.75H3.071v3.107H1Zm3.107,1.036H7.214v2.071H4.107Zm4.143,0h3.107v2.071H8.25ZM1,20.607H3.071v3.107H1Zm8.286,1.036h2.071V24.75H9.286Z",
    transform: "translate(14 206.092)",
    fill: "rgba(255,255,255,0.38)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "simple-line-icons_cursor-move",
    d: "M370.568,3.173l1.685,1.858a.543.543,0,0,0,.786.073l.2-.133a.6.6,0,0,0,0-.822l-2.75-3.013a.775.775,0,0,0-.3-.323l-.035-.036a.538.538,0,0,0-.394-.17.544.544,0,0,0-.4.17l-.2.206s0,.009-.008.013l-2.807,3.1a.6.6,0,0,0,0,.822l.2.133a.544.544,0,0,0,.787-.073l1.681-1.874c-.017,9.018,0,10.705,0,10.694v9.162l-1.681-1.874a.544.544,0,0,0-.787-.074l-.2.133a.6.6,0,0,0,0,.822l2.807,3.1s0,.009.008.013l.2.206a.545.545,0,0,0,.79,0l.2-.206a.111.111,0,0,0,.009-.013l2.878-3.153a.6.6,0,0,0,0-.822l-.2-.133a.544.544,0,0,0-.786.074L370.568,22.9V3.173Z",
    transform: "translate(-336.203 208.485)",
    fill: "rgba(255,255,255,0.38)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragdropIcon);
export default __webpack_public_path__ + "static/media/dragdropIcon.266bfc0001d03b29475cc62b24c72cce.svg";
export { ForwardRef as ReactComponent };